export const __TEST__ = process.env.JEST_WORKER_ID !== undefined;
export const __DEV__ = process.env.NODE_ENV !== 'production';
export const __CLIENT_SIDE__ = typeof window !== 'undefined';
